import { render, staticRenderFns } from "./SyncSwitch.vue?vue&type=template&id=f98f76e8"
import script from "./SyncSwitch.vue?vue&type=script&lang=js"
export * from "./SyncSwitch.vue?vue&type=script&lang=js"
import style0 from "./SyncSwitch.vue?vue&type=style&index=0&id=f98f76e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports